import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'n2br'
})
export class N2brPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let tmp = value ? value + '' : '';
    if (tmp) {
      return tmp.replace(/\n/g, "<br/>");
    } else {
      return tmp;
    }
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/core/pipe/n2br.pipe.ts